// extracted by mini-css-extract-plugin
export default {"assessHealthGraph":"assess-health-graph_assessHealthGraph__h3Cds","score":"assess-health-graph_score__WW72G","needle":"assess-health-graph_needle__GmMe7"};